// extracted by mini-css-extract-plugin
module.exports = {"player-icon-mask":"eP","playerIconMask":"eP","player-icon-box":"eQ","playerIconBox":"eQ"};